import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalStateProvider } from '#pplx/frontend/aether/modals/internal/ModalStateProvider.js';
import { ModalStoreProvider } from '#pplx/frontend/aether/modals/internal/ModalStoreProvider.js';
import { GlobalModalRenderer } from '#pplx/frontend/aether/modals/render/GlobalModalRenderer.js';
import { memo } from 'react';
export const ModalProvider = memo(function ModalProvider({ children, logger, render, }) {
    return (_jsx(ModalStoreProvider, { children: _jsxs(ModalStateProvider, { logger: logger, children: [children, render && _jsx(GlobalModalRenderer, { logger: logger })] }) }));
});
//# sourceMappingURL=ModalProvider.js.map